import { useEffect } from "react";
import "./style.scss"
const YouTube = () => {
    useEffect(() => {
        document.title = 'Sino-bus 帶你走進中文世界';
    }, []);

    const go = () => {
        let url = "https://wa.me/8617788052878?text=%E5%92%A8%E8%A9%A2%E8%AA%B2%E7%A8%8B";
        window.open(url, "_blank");
    }

    return <div className="youTube" onClick={() => { go() }}>
        <div className="pc" >
            <img className="youtubePc" src="../../../../assets/youtubePc.png" alt="" />
        </div>
        <div className="mob">
            <img className="youtubeMob" src="../../../../assets/youtubeMob1.png" alt="" />
        </div>
    </div>
}
export default YouTube;